module.exports = __webpack_public_path__ + "img/prompt_pay.6af324c3.png";